import React, { useEffect, useState } from 'react';
import styles from './contacts-page.module.css';
import { addContactsBd, getContactsBd } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import HeaderBack from '../../components/HeaderBack/HeaderBack';

export default function ContactsPage() {
  const [loaderPage, setLoaderPage] = useState(false);
  const [tel, setTel] = useState('');
  const [instagramLink, setInstagramLink] = useState('');
  const [videoLink, setVideoLink] = useState('');
  const [text, setText] = useState('');

  const addContacts = async (value) => {
    setLoaderPage(true);
    const isAddContactsBd = await addContactsBd(value);

    if (isAddContactsBd) {
      alert('Контакти додані успішно.');
    } else {
      alert('Помилка при додавані контактів.');
    }
    setLoaderPage(false);
  };

  useEffect(() => {
    setLoaderPage(true);
    const getContacts = async () => {
      const contacts = await getContactsBd();
      if (contacts) {
        setTel(contacts.tel);
        setInstagramLink(contacts.instagramLink);
        setVideoLink(contacts.videoLink);
        setText(contacts.text);
      }
      setLoaderPage(false);
    };
    getContacts();
  }, []);

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <HeaderBack />
      {/* -------------- /Header ------------------------ */}

      <div className={styles.content_wrapper}>
        <div>
          Телефон
          <small> (За цим номером має бути Телеграм і Вайбер)</small>
          <input
            className={styles.popup_input}
            type="tel"
            value={tel}
            placeholder="380966054541"
            onChange={(e) => setTel(e.target.value)}
          />
          Посилання на Instagram
          <input
            className={styles.popup_input}
            type="text"
            value={instagramLink}
            onChange={(e) => setInstagramLink(e.target.value)}
          />
          Посилання на відео з використання додатку
          <input
            className={styles.popup_input}
            type="text"
            value={videoLink}
            onChange={(e) => setVideoLink(e.target.value)}
          />
          Текст
          <textarea
            className={styles.textarea}
            value={text}
            rows="8"
            placeholder="Текст..."
            onChange={(e) => setText(e.target.value)}></textarea>
          <small>Ці дані будуть відображатися в "Підтримці"</small>
          <button
            className={styles.save_btn}
            onClick={() =>
              addContacts({
                tel: tel.trim(),
                instagramLink: instagramLink.trim(),
                videoLink: videoLink.trim(),
                text: text,
              })
            }>
            Зберегти
          </button>
        </div>
      </div>

      {loaderPage && <LoaderPage />}
    </>
  );
}
